import styled, { css } from 'styled-components';
import { nuDSColor, spacing } from '@nubank/nuds-web/styles/themeUtils';
import { breakpointsMediaUp } from '@nubank/nuds-web/styles/breakpoints';

import Chip from '@nubank/www-latam-commons/components/Chip/Chip';

export const StyledChip = styled(Chip)`
  font-size: .875rem;
  display: inline-block;
  padding: ${spacing('1x', '3x')};
  margin-left: ${spacing('2x')};
  cursor: default;

  ${breakpointsMediaUp({
    md: css`
      vertical-align: top;
    `,
  })}

  span {
    font-size: .875rem;
    line-height: 1.25rem;
  }

  &:hover,
  &:focus {
    ${({ backgroundColor }) => backgroundColor
    && css`
      background-color: ${nuDSColor(backgroundColor)};
    `}
  }
`;

StyledChip.defaultProps = {
  backgroundColor: 'primary.defaultL10',
};

StyledChip.displayName = 'StyledChip';
